/**
 * SA Tools AI Service
 * API calls for AI-powered features using AWS Bedrock
 */
import apiClient from './api';

export const aiService = {
  /**
   * Generate AI ratings for all processes
   * POST /satools/ai/generate-ratings
   */
  generateRatings: async (customerId, processes, context) => {
    try {
      const response = await apiClient.post('/satools/ai/generate-ratings', {
        customerId,
        processes,
        context
      });
      return response.data;
    } catch (error) {
      console.error('Error generating AI ratings:', error);
      throw error;
    }
  },

  /**
   * Rewrite introduction with customer-specific context
   * POST /satools/ai/rewrite-introduction
   */
  rewriteIntroduction: async (customerId, context) => {
    try {
      const response = await apiClient.post('/satools/ai/rewrite-introduction', {
        customerId,
        context
      });
      return response.data;
    } catch (error) {
      console.error('Error rewriting introduction:', error);
      throw error;
    }
  },

  /**
   * Rewrite approach section
   * POST /satools/ai/rewrite-approach
   */
  rewriteApproach: async (customerId, context) => {
    try {
      const response = await apiClient.post('/satools/ai/rewrite-approach', {
        customerId,
        context
      });
      return response.data;
    } catch (error) {
      console.error('Error rewriting approach:', error);
      throw error;
    }
  },

  /**
   * Rewrite recommended approach section
   * POST /satools/ai/rewrite-recommended-approach
   */
  rewriteRecommendedApproach: async (customerId, context) => {
    try {
      const response = await apiClient.post('/satools/ai/rewrite-recommended-approach', {
        customerId,
        context
      });
      return response.data;
    } catch (error) {
      console.error('Error rewriting recommended approach:', error);
      throw error;
    }
  },

  /**
   * Rewrite process summary
   * POST /satools/ai/rewrite-process-summary
   */
  rewriteProcessSummary: async (customerId, summary, context) => {
    try {
      const response = await apiClient.post('/satools/ai/rewrite-process-summary', {
        customerId,
        summary,
        context
      });
      return response.data;
    } catch (error) {
      console.error('Error rewriting process summary:', error);
      throw error;
    }
  },

  /**
   * Rescore a single process with AI
   * POST /satools/ai/rescore-process
   */
  rescoreProcess: async (process, context) => {
    try {
      const response = await apiClient.post('/satools/ai/rescore-process', {
        process,
        context
      });
      return response.data;
    } catch (error) {
      console.error('Error rescoring process:', error);
      throw error;
    }
  }
};

export default aiService;
